/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import {
  Container,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Stack,
  Typography,
  Box,
  MenuItem,
  OutlinedInput,
  Select,
  InputLabel,
  FormControl,
  Autocomplete,
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Icon from '@material-ui/core/Icon';
import Page from '../../../Page';
import { makeStyles } from '@material-ui/styles';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Services from '../Service';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import Divider from '@material-ui/core/Divider';
import { AlertDialog } from './../../Common/AlertDialog';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '1.2rem',
    color: '#1a1a1a',
  },
  sectionCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    marginBottom: '1.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  },
  sectionTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: '0.75rem',
    color: '#1a1a1a',
  },
  skuTableHead: {
    backgroundColor: '#f5f5f5',
  },
  skuTableHeadCell: {
    fontWeight: 600,
    fontSize: '0.82rem',
    color: '#555',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  skuTableRow: {
    '&:last-child td': { borderBottom: 0 },
  },
  addRowBtn: {
    border: '1px solid #bdbdbd',
    borderRadius: '4px',
    color: '#444',
    textTransform: 'none',
    fontWeight: 500,
    padding: '4px 12px',
    fontSize: '0.82rem',
    marginTop: '0.5rem',
  },
  clearBtn: {
    borderColor: '#e57373',
    color: '#e57373',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '20px',
    padding: '5px 22px',
    '&:hover': { backgroundColor: '#ffeaea', borderColor: '#e57373' },
  },
  searchBtn: {
    borderColor: '#1976d2',
    color: '#1976d2',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '20px',
    padding: '5px 22px',
    '&:hover': { backgroundColor: '#e3f0ff', borderColor: '#1976d2' },
  },
  saveBtn: {
    backgroundColor: '#1565c0',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '6px',
    padding: '8px 28px',
    '&:hover': { backgroundColor: '#0d47a1' },
  },
}));

var screenCode = "STOCKADJUSTMENT";
export default function StockAdjustmentAddEdit(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const todayDate = (() => {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  })();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  const [groupList, setGroupList] = useState([]);
  const [operationEntityTypeList, setOperationEntityTypeList] = useState([]);
  const [factoryList, setFactoryList] = useState([]);
  const [adjustmentTypeList, setAdjustmentTypeList] = useState([]);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [availableQuantity, setAvailableQuantity] = useState(null);
  const [formData, setFormData] = useState({
    groupID: 0,
    operationEntityTypeID: 1,
    factoryID: 0,
    adjustmentTypeID: 0,
    otherAdjustmentReason: '',
    entryType: '0',
    productCategoryID: 0,
    productID: 0,
    quantity: '',
    adjustmentDate: todayDate,
  });

  const entryTypes = [
    { value: 'IN', label: 'Plus (Debit)' },
    { value: 'OUT', label: 'Minus (Credit)' }
  ];

  function isOtherAdjustmentType(adjustmentTypeID) {
    var selected = adjustmentTypeList.find(x => x.adjustmentTypeID == parseInt(adjustmentTypeID));
    return selected !== undefined && selected.adjustmentTypeCode == 'OTHER';
  }

  const stockAdjustmentSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityTypeID: Yup.number().min(1, 'Please Select Operation Entity Type').required('Operation Entity Type Required'),
    factoryID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity Required'),
    adjustmentTypeID: Yup.number().min(1, 'Please Select Adjustment Type').required('Adjustment Type Required'),
    otherAdjustmentReason: Yup.string().test('other-reason-required', 'Adjustment Reason Required', function (value) {
      if (isOtherAdjustmentType(this.parent.adjustmentTypeID)) {
        return value != null && value.trim() != "";
      }
      return true;
    }),
    entryType: Yup.string().notOneOf(["0"], 'Please Select Entry Type').required('Entry Type Required'),
    productCategoryID: Yup.number().min(1, 'Please Select Product Category').required('Product Category Required'),
    productID: Yup.number().min(1, 'Please Select Product').required('Product Required'),
    adjustmentDate: Yup.string().required('Adjustment Date Required'),
    quantity: Yup.number().typeError('Quantity must be a number').positive('Quantity must be greater than zero').required('Quantity Required')
      .test('max-decimals', 'Quantity can have at most 2 decimal places', function (value) {
        return value == null || /^\d+(\.\d{1,2})?$/.test(value.toString());
      })
      .test('available-stock', function (value) {
        if (pageProps.isEdit || this.parent.entryType != 'OUT' || availableQuantity == null || value == null) {
          return true;
        }
        var pendingQuantity = adjustmentRows
          .filter(x => x.productID == parseInt(this.parent.productID))
          .reduce((total, x) => total + x.quantity, 0);
        var remainingQuantity = availableQuantity - pendingQuantity;
        if (remainingQuantity < 0) {
          remainingQuantity = 0;
        }
        if (value > remainingQuantity) {
          return this.createError({ message: 'Available quantity is ' + remainingQuantity });
        }
        return true;
      })
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityTypeID: formData.operationEntityTypeID,
      factoryID: formData.factoryID,
      adjustmentTypeID: formData.adjustmentTypeID,
      otherAdjustmentReason: formData.otherAdjustmentReason,
      entryType: formData.entryType,
      productCategoryID: formData.productCategoryID,
      productID: formData.productID,
      quantity: formData.quantity,
      adjustmentDate: formData.adjustmentDate,
    },
    validationSchema: stockAdjustmentSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit) {
        setEnableConfirmMessage2(true);
      } else {
        handleAddRow(values);
      }
    }
  });

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  const [adjustmentRows, setAdjustmentRows] = useState([]);
  const [message, setMessage] = useState("Save Confirmation");
  const [message2, setMessage2] = useState("Update Confirmation");
  const [message3, setMessage3] = useState("Back Confirmation");
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);
  const [EnableConfirmMessage3, setEnableConfirmMessage3] = useState(false);
  const [productCategoryWarning, setProductCategoryWarning] = useState(false);
  const [productOpen, setProductOpen] = useState(false);

  const productAutocompleteFilter = (options, state) => {
    const input = (state.inputValue || '').trim().toLowerCase();
    if (input === '') {
        return options;
    }
    return options
        .filter((option) => (option.productName || '').toLowerCase().includes(input))
        .sort((a, b) => {
            const aName = (a.productName || '').toLowerCase();
            const bName = (b.productName || '').toLowerCase();
            const aExact = aName === input ? 0 : 1;
            const bExact = bName === input ? 0 : 1;
            return aExact - bExact;
        });
  };

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    pageName: 'Add Stock Adjustment',
  });

  const { stockAdjustmentID } = useParams();
  const initialFactoryLoadRef = useRef(true);

  useEffect(() => {
    const decrypted = AESDecryptionParam(stockAdjustmentID);
    if (decrypted != 0) {
      setPageProps({
        ...pageProps,
        isEdit: true,
        editingID: parseInt(decrypted),
        pageName: 'Update Stock Adjustment',
      });
      trackPromise(GetStockAdjustmentByStockAdjustmentID(parseInt(decrypted)));
    }
    getPermissions();
  }, []);

  useEffect(() => {
    function handleBeforeUnload(e) {
      e.preventDefault();
      e.returnValue = '';
    }
    if (adjustmentRows.length > 0) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [adjustmentRows]);

  useEffect(() => {
    if (pageProps.isEdit) {
      return;
    }
    setFactoryList([]);
    if (initialFactoryLoadRef.current) {
      if (values.groupID > 0 && values.operationEntityTypeID > 0) {
        initialFactoryLoadRef.current = false;
        trackPromise(loadFactories());
      }
      return;
    }
    if (values.factoryID > 0) {
      formik.setFieldValue('factoryID', 0);
    }
    if (values.groupID > 0 && values.operationEntityTypeID > 0) {
      trackPromise(loadFactories());
    }
  }, [values.groupID, values.operationEntityTypeID]);

  useEffect(() => {
    if (pageProps.isEdit) {
      return;
    }
    setProductList([]);
    setProductCategoryWarning(false);
    formik.setFieldValue('quantity', '');
    if (values.productID > 0) {
      formik.setFieldValue('productID', 0);
    }
    if (values.productCategoryID > 0) {
      trackPromise(loadProducts());
    }
  }, [values.productCategoryID]);

  useEffect(() => {
    if (pageProps.isEdit) {
      return;
    }
    setAvailableQuantity(null);
    formik.setFieldValue('quantity', '');
    if (values.factoryID > 0 && values.productID > 0) {
      trackPromise(loadAvailableStock());
    }
  }, [values.productID]);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'ADDEDITSTOCKADJUSTMENT');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');
    setPermissions({
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const isEditMode = AESDecryptionParam(stockAdjustmentID) != 0;
    if (!isEditMode) {
      setValues({
        ...values,
        groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        operationEntityTypeID: parseInt(TokenDecoder.getFactoryTypeFromToken()),
        factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
        adjustmentDate: todayDate
      });
    }

    trackPromise(loadGroups());
    trackPromise(loadOperationEntityTypes());
    trackPromise(loadAdjustmentTypes());
    trackPromise(loadProductCategories());
  }

  async function loadGroups() {
    var res = await Services.GetAllGroupsForDropDown();
    if (res != null) setGroupList(res);
  }

  async function loadOperationEntityTypes() {
    var res = await Services.GetAllOperationEntityTypes();
    if (res != null) setOperationEntityTypeList(res);
  }

  async function loadAdjustmentTypes() {
    var res = await Services.GetAllAdjustmentTypes();
    if (res != null) setAdjustmentTypeList(res);
  }

  async function loadProductCategories() {
    var res = await Services.GetProductCategoties();
    if (res != null) setProductCategoryList(res);
  }

  async function loadFactories() {
    var res = await Services.GetAllFactoriesByFactoryType(values.groupID, values.operationEntityTypeID);
    if (res != null) setFactoryList(res);
  }

  async function loadProducts() {
    var res = await Services.GetProductDetails(values.factoryID, values.productCategoryID);
    if (res != null) setProductList(res);
  }

  async function loadAvailableStock() {
    var res = await Services.GetAvailableStockQuantity(values.groupID, values.factoryID, values.productCategoryID, values.productID);
    if (res != null) {
      setAvailableQuantity(res.availableQuantity);
    } else {
      setAvailableQuantity(0);
    }
  }

  function handleAddRow(values) {
    var isDuplicate = adjustmentRows.find(x => x.factoryID == parseInt(values.factoryID)
      && x.productID == parseInt(values.productID)
      && x.entryType == values.entryType
      && x.adjustmentTypeID == parseInt(values.adjustmentTypeID));

    if (isDuplicate !== undefined) {
      toast.error("This product adjustment is already added to the list");
      return;
    }

    var selectedFactory = factoryList.find(x => x.factoryID == parseInt(values.factoryID));
    var selectedEntityType = operationEntityTypeList.find(x => x.operationEntityTypeID == parseInt(values.operationEntityTypeID));
    var selectedAdjustmentType = adjustmentTypeList.find(x => x.adjustmentTypeID == parseInt(values.adjustmentTypeID));
    var selectedCategory = productCategoryList.find(x => x.productCategoryID == parseInt(values.productCategoryID));
    var selectedProduct = productList.find(x => x.productID == parseInt(values.productID));

    var entry = {
      stockAdjustmentID: 0,
      groupID: parseInt(values.groupID),
      factoryID: parseInt(values.factoryID),
      factoryName: selectedFactory === undefined ? '' : selectedFactory.factoryName,
      operationEntityTypeID: parseInt(values.operationEntityTypeID),
      operationEntityTypeName: selectedEntityType === undefined ? '' : selectedEntityType.operationEntityTypeName,
      adjustmentTypeID: parseInt(values.adjustmentTypeID),
      adjustmentTypeName: selectedAdjustmentType === undefined ? '' : selectedAdjustmentType.adjustmentTypeName,
      adjustmentTypeCode: selectedAdjustmentType === undefined ? '' : selectedAdjustmentType.adjustmentTypeCode,
      otherAdjustmentReason: isOtherAdjustmentType(values.adjustmentTypeID) ? values.otherAdjustmentReason : "",
      entryType: values.entryType,
      productCategoryID: parseInt(values.productCategoryID),
      productCategoryName: selectedCategory === undefined ? '' : selectedCategory.productCategoryName,
      productID: parseInt(values.productID),
      productName: selectedProduct === undefined ? '' : selectedProduct.productName,
      productCode: selectedProduct === undefined ? '' : selectedProduct.productCode,
      quantity: parseFloat(values.quantity),
      adjustmentDate: values.adjustmentDate,
      createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    };

    setAdjustmentRows([...adjustmentRows, entry]);

    setValues({
      ...values,
      productCategoryID: 0,
      productID: 0,
      quantity: '',
      otherAdjustmentReason: ''
    });
    formik.setTouched({});
  }

  function handleRemoveRow(index) {
    setAdjustmentRows((prev) => prev.filter((r, i) => i !== index));
  }

  function handleQuantityChange(e) {
    const value = e.target.value;
    const decimalRegex = /^\d*\.?\d{0,2}$/;
    if (value === '' || decimalRegex.test(value)) {
      formik.setFieldValue('quantity', value);
    }
  }

  function handleClear() {
    if (pageProps.isEdit) {
      setValues({
        ...values,
        quantity: formData.quantity == null ? '' : Number(formData.quantity).toFixed(2)
      });
    } else if (adjustmentRows.length > 0) {
      setValues({
        ...values,
        productCategoryID: 0,
        productID: 0,
        quantity: ''
      });
    } else {
      setValues({
        ...values,
        adjustmentTypeID: 0,
        otherAdjustmentReason: '',
        entryType: '0',
        productCategoryID: 0,
        productID: 0,
        quantity: '',
        adjustmentDate: todayDate
      });
    }
    formik.setTouched({});
  }

  async function GetStockAdjustmentByStockAdjustmentID(stockAdjustmentID) {
    var res = await Services.GetStockAdjustmentByStockAdjustmentID(stockAdjustmentID);
    if (res != null) {
      setFactoryList([{ factoryID: res.factoryID, factoryName: res.factoryName, isActive: true }]);
      setProductCategoryList([{ productCategoryID: res.productCategoryID, productCategoryName: res.productCategoryName }]);
      setProductList([{ productID: res.productID, productName: res.productName, productCode: res.productCode }]);
      setValues((prevState) => ({
        ...prevState,
        groupID: res.groupID,
        operationEntityTypeID: res.operationEntityTypeID,
        factoryID: res.factoryID,
        adjustmentTypeID: res.adjustmentTypeID,
        otherAdjustmentReason: res.otherAdjustmentReason == null ? '' : res.otherAdjustmentReason,
        entryType: res.entryType,
        productCategoryID: res.productCategoryID,
        productID: res.productID,
        quantity: res.quantity == null ? '' : Number(res.quantity).toFixed(2),
        adjustmentDate: res.adjustmentDate == null ? '' : res.adjustmentDate.split('T')[0]
      }));
      setFormData(res);
    }
  }

  async function handleSaveAdjustments() {
    if (adjustmentRows.length == 0) {
      toast.warning('Please add Stock Adjustment details before saving.');
      return;
    }
    var res = await Services.SaveStockAdjustments(adjustmentRows);
    if (res.statusCode == 'Success') {
      setAdjustmentRows([]);
      sessionStorage.setItem('stockAdjustmentSuccessMessage', res.message);
      navigate('/dashboard/StockAdjustment')
    }
    else {
      toast.error(res.message);
    }
  }

  async function handleUpdateQuantity() {
    let model = {
      stockAdjustmentID: pageProps.editingID,
      quantity: parseFloat(values.quantity),
      modifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
    }
    var res = await Services.UpdateStockAdjustmentQuantity(model);
    if (res.statusCode == 'Success') {
      sessionStorage.setItem('stockAdjustmentSuccessMessage', res.message);
      navigate('/dashboard/StockAdjustment', { state: { fromAddEdit: true } })
    }
    else {
      toast.error(res.message);
    }
  }

  function confirmData(y) {
    if (y) {
      trackPromise(handleSaveAdjustments());
    }
  }

  function confirmData2(y) {
    if (y) {
      trackPromise(handleUpdateQuantity());
    }
  }

  function handleBack() {
    if (pageProps.isEdit == false && adjustmentRows.length > 0) {
      setEnableConfirmMessage3(true);
    } else {
      navigate('/dashboard/StockAdjustment', { state: { fromAddEdit: true } });
    }
  }

  function confirmData3(y) {
    if (y) {
      navigate('/dashboard/StockAdjustment', { state: { fromAddEdit: true } });
    }
  }

  const entityFieldsLocked = pageProps.isEdit || adjustmentRows.length > 0;

  return (
    <>
      <LoadingComponent />
      <Page title="Stock Adjustment | FAPS">
        <Container maxWidth="lg">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom>
              {pageProps.pageName}
            </Typography>
            <Button
              variant="contained"
              to="#"
              color='secondary'
              onClick={() => handleBack()}
              startIcon={<Icon>backspaceIcon</Icon>}
            >
              Back
            </Button>
          </Stack>

          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={4}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    disabled={!permissionList.isGroupFilterEnabled || entityFieldsLocked}
                  >
                    <MenuItem key={0} value={0}> Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Operation Entity Type *"
                    value={formik.values.operationEntityTypeID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityTypeID')}
                    error={Boolean(touched.operationEntityTypeID && errors.operationEntityTypeID)}
                    helperText={touched.operationEntityTypeID && errors.operationEntityTypeID}
                    disabled={!permissionList.isFactoryFilterEnabled || entityFieldsLocked}
                  >
                    <MenuItem key={0} value={0}> Select Operation Entity Type</MenuItem>
                    {operationEntityTypeList.map((option) => (
                      <MenuItem key={option.operationEntityTypeID} value={option.operationEntityTypeID}>
                        {option.operationEntityTypeName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Operation Entity *"
                    value={formik.values.factoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('factoryID')}
                    error={Boolean(touched.factoryID && errors.factoryID)}
                    helperText={touched.factoryID && errors.factoryID}
                    disabled={!permissionList.isFactoryFilterEnabled || entityFieldsLocked}
                  >
                    <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                    {factoryList.map((option) => (
                      <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Adjustment Type *"
                    value={formik.values.adjustmentTypeID}
                    onChange={formik.handleChange}
                    {...getFieldProps('adjustmentTypeID')}
                    error={Boolean(touched.adjustmentTypeID && errors.adjustmentTypeID)}
                    helperText={touched.adjustmentTypeID && errors.adjustmentTypeID}
                    disabled={entityFieldsLocked}
                  >
                    <MenuItem key={0} value={0}> Select Adjustment Type</MenuItem>
                    {adjustmentTypeList.map((option) => (
                      <MenuItem key={option.adjustmentTypeID} value={option.adjustmentTypeID}>
                        {option.adjustmentTypeName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Entry Type *"
                    value={formik.values.entryType}
                    onChange={formik.handleChange}
                    {...getFieldProps('entryType')}
                    error={Boolean(touched.entryType && errors.entryType)}
                    helperText={touched.entryType && errors.entryType}
                    disabled={entityFieldsLocked}
                  >
                    <MenuItem key={0} value={'0'}> Select Entry Type</MenuItem>
                    {entryTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    fullWidth
                    size="small"
                    label="Adjustment Date *"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={formik.values.adjustmentDate}
                    onChange={formik.handleChange}
                    {...getFieldProps('adjustmentDate')}
                    error={Boolean(touched.adjustmentDate && errors.adjustmentDate)}
                    helperText={touched.adjustmentDate && errors.adjustmentDate}
                    inputProps={{ max: todayDate }}
                    disabled={entityFieldsLocked}
                  >
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Product Category *"
                    value={formik.values.productCategoryID}
                    onChange={formik.handleChange}
                    {...getFieldProps('productCategoryID')}
                    error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                    helperText={touched.productCategoryID && errors.productCategoryID}
                    disabled={pageProps.isEdit}
                  >
                    <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                    {productCategoryList.map((option) => (
                      <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                        {option.productCategoryName}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Autocomplete
                    fullWidth
                    id="productID"
                    options={productList}
                    filterOptions={productAutocompleteFilter}
                    getOptionLabel={(option) => option.productName || ''}
                    isOptionEqualToValue={(option, value) => option.productID === value.productID}
                    value={productList.find((x) => x.productID == formik.values.productID) || null}
                    onChange={(e, value) => formik.setFieldValue('productID', value === null ? 0 : value.productID)}
                    disabled={pageProps.isEdit}
                    open={productOpen}
                    onOpen={() => {
                        if (pageProps.isEdit) {
                            return;
                        }
                        if (!(formik.values.productCategoryID > 0)) {
                            setProductCategoryWarning(true);
                            return;
                        }
                        setProductCategoryWarning(false);
                        setProductOpen(true);
                    }}
                    onClose={() => setProductOpen(false)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            name="productID"
                            label="Product *"
                            size="small"
                            fullWidth
                            error={Boolean(productCategoryWarning || (touched.productID && errors.productID))}
                            helperText={
                                productCategoryWarning
                                    ? 'Please select a Category first'
                                    : (touched.productID && errors.productID)
                            }
                        />
                    )}
                />
                </Stack>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    size="small"
                    label="Quantity *"
                    placeholder="Enter Quantity"
                    type="number"
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: { xs: '100%', sm: 'calc(25% - 12px)' } }}
                    value={formik.values.quantity}
                    {...getFieldProps('quantity')}
                    onChange={handleQuantityChange}
                    onKeyDown={(evt) =>
                      ['-', '+', 'e', 'E'].includes(evt.key) && evt.preventDefault()
                    }
                    error={Boolean(touched.quantity && errors.quantity)}
                    helperText={touched.quantity && errors.quantity}
                    inputProps={{ min: 0, step: "0.01" }}
                  >
                  </TextField>
                </Stack>
                {isOtherAdjustmentType(formik.values.adjustmentTypeID) ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Adjustment Reason *"
                      value={formik.values.otherAdjustmentReason}
                      onChange={formik.handleChange}
                      {...getFieldProps('otherAdjustmentReason')}
                      error={Boolean(touched.otherAdjustmentReason && errors.otherAdjustmentReason)}
                      helperText={touched.otherAdjustmentReason && errors.otherAdjustmentReason}
                      InputProps={{
                        readOnly: pageProps.isEdit
                      }}
                      inputProps={{ maxLength: 200 }}
                    >
                    </TextField>
                  </Stack>
                  : null}
                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                  {!pageProps.isEdit ?
                    <Button
                      type="button"
                      variant="outlined"
                      className={classes.clearBtn}
                      onClick={() => handleClear()}
                    >Clear</Button>
                    : null}
                  <Button
                    type="submit"
                    variant="outlined"
                    className={classes.searchBtn}
                    startIcon={pageProps.isEdit ? null : <AddIcon style={{ fontSize: '0.9rem' }} />}
                  >{pageProps.isEdit ? 'Update' : 'Add'}</Button>
                </Stack>
              </Stack>

              {pageProps.isEdit == false && adjustmentRows.length > 0 ?
                <>
                  <br /><Divider variant="middle" /><br />
                  <Box mb={2.5}>
                    <Card className={classes.sectionCard} style={{ marginBottom: 0 }}>
                      <CardContent style={{ paddingBottom: '12px' }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                          <Typography className={classes.sectionTitle}>Adjustment Details</Typography>
                        </Stack>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow style={{ backgroundColor: '#f9f9f9' }}>
                                <TableCell className={classes.skuTableHeadCell}>Operation Entity Type</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Operation Entity</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Adjustment Type</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Entry Type</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Product Code</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Product Category</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Product</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Quantity</TableCell>
                                <TableCell className={classes.skuTableHeadCell}>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {adjustmentRows.length == 0 ?
                                <TableRow className={classes.skuTableRow}>
                                  <TableCell colSpan={9} align="center" style={{ fontStyle: 'italic', color: '#777' }}>
                                    No Data Available
                                  </TableCell>
                                </TableRow>
                                : <>
                                  {adjustmentRows.map((row, index) => (
                                    <TableRow key={index} className={classes.skuTableRow}>
                                      <TableCell>
                                        {row.operationEntityTypeName}
                                      </TableCell>
                                      <TableCell>
                                        {row.factoryName}
                                      </TableCell>
                                      <TableCell>
                                        {row.adjustmentTypeCode == 'OTHER' ? row.adjustmentTypeName + ' - ' + row.otherAdjustmentReason : row.adjustmentTypeName}
                                      </TableCell>
                                      <TableCell>
                                        {row.entryType == 'IN' ? 'Plus (Debit)' : 'Minus (Credit)'}
                                      </TableCell>
                                      <TableCell>
                                        {row.productCode}
                                      </TableCell>
                                      <TableCell>
                                        {row.productCategoryName}
                                      </TableCell>
                                      <TableCell>
                                        {row.productName}
                                      </TableCell>
                                      <TableCell>
                                        {row.quantity.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        <IconButton size="small" onClick={() => handleRemoveRow(index)}>
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  ))}</>}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                    </Card>
                  </Box>
                  <Stack direction="row" justifyContent="flex-end" mb={3}>
                    <Button
                      variant="contained"
                      color="secondary"
                      type="button"
                      onClick={() => setEnableConfirmMessage(true)}
                    >
                      ADD
                    </Button>
                  </Stack>
                </>
                : null}
            </Form>
          </FormikProvider>
        </Container>
        <div hidden={true}>
          <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
            discription={"Are you sure you want to save these stock adjustments ?"} setViewPopup={setEnableConfirmMessage} />
        </div>
        <div hidden={true}>
          <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
            discription={"Are you sure you want to update this stock adjustment quantity ?"} setViewPopup={setEnableConfirmMessage2} />
        </div>
        <div hidden={true}>
          <AlertDialog confirmData={confirmData3} headerMessage={message3} viewPopup={EnableConfirmMessage3}
            discription={"There are unsaved stock adjustments in the list. Are you sure you want to go back ?"} setViewPopup={setEnableConfirmMessage3} />
        </div>
      </Page>
    </>
  );
}
